import { render, staticRenderFns } from "./BranchDrawer.vue?vue&type=template&id=c2fb9100&scoped=true"
import script from "./BranchDrawer.vue?vue&type=script&lang=js"
export * from "./BranchDrawer.vue?vue&type=script&lang=js"
import style0 from "./BranchDrawer.vue?vue&type=style&index=0&id=c2fb9100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fb9100",
  null
  
)

export default component.exports